"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mockCourses = [
    {
        course_id: 1,
        name: 'go',
        display_name: 'Go',
        type: 'system',
        total: 35,
        not_started: 30,
        completed: 0,
        in_progress: 5,
        average_completion_points: 1400,
        average_completion_seconds: 18465,
    },
    {
        course_id: 14,
        name: 'java',
        display_name: 'Java',
        type: 'system',
        total: 19,
        not_started: 14,
        completed: 0,
        in_progress: 5,
        average_completion_points: 800,
        average_completion_seconds: 9544,
    },
    {
        course_id: 193,
        name: 'dev_test_1607202168',
        display_name: 'Test',
        type: 'custom',
        total: 16,
        not_started: 9,
        completed: 0,
        in_progress: 7,
        average_completion_points: 524,
        average_completion_seconds: 7000,
    },
    {
        course_id: 2,
        name: 'cplus',
        display_name: 'C/C++',
        type: 'system',
        total: 15,
        not_started: 11,
        completed: 1,
        in_progress: 3,
        average_completion_points: 1852,
        average_completion_seconds: 4167,
    },
    {
        course_id: 6,
        name: 'frontend',
        display_name: 'Front End Security Basics',
        type: 'system',
        total: 13,
        not_started: 9,
        completed: 0,
        in_progress: 4,
        average_completion_points: 3445,
        average_completion_seconds: 80844,
    },
    {
        course_id: 8,
        name: 'hacking_headlines',
        display_name: 'Hacking Headlines',
        type: 'system',
        total: 12,
        not_started: 10,
        completed: 0,
        in_progress: 2,
        average_completion_points: 3000,
        average_completion_seconds: 2000,
    },
    {
        course_id: 191,
        name: 'dev_test_1607202129',
        display_name: 'Test',
        type: 'custom',
        total: 11,
        not_started: 3,
        completed: 0,
        in_progress: 8,
        average_completion_points: 8000,
        average_completion_seconds: 7000,
    },
    {
        course_id: 189,
        name: 'dev_rr_1606990788',
        display_name: 'rr',
        type: 'custom',
        total: 11,
        not_started: 2,
        completed: 1,
        in_progress: 8,
        average_completion_points: 3504,
        average_completion_seconds: 9705,
    },
    {
        course_id: 190,
        name: 'dev_rr_1606990802',
        display_name: 'rr',
        type: 'custom',
        total: 11,
        not_started: 2,
        completed: 1,
        in_progress: 8,
        average_completion_points: 605,
        average_completion_seconds: 3077,
    },
    {
        course_id: 192,
        name: 'dev_test_1607202150',
        display_name: 'Test',
        type: 'custom',
        total: 10,
        not_started: 4,
        completed: 1,
        in_progress: 5,
        average_completion_points: 9988,
        average_completion_seconds: 6458,
    },
];
var teamsData = [
    { id: 54, name: 'bananas' },
    { id: 1, name: 'Development Team' },
    { id: 69, name: 'Managed Team' },
    { id: 74, name: 'Ors Team' },
    { id: 56, name: 'Test empty' },
    { id: 2, name: 'Testing team' },
    { id: 53, name: 'The B Team' },
    { id: 72, name: 'The Markers' },
    { id: 39, name: 'TournamentsGameFlowTesters' },
];
var mainDashboardTeamFilterData = {
    primary_courses: { not_started: 62, in_progress: 8, completed: 0 },
    assigned_lessons: { not_started: 1, in_progress: 1, completed: 1 },
    primary_and_assigned: { not_started: 62, in_progress: 8, completed: 0 },
    lesson_engagement: { not_started: 1347, completed: 360 },
    lessons_by_users: [
        { title: '0-9', value: 6 },
        { title: '10-19', value: 1 },
        { title: '20-29', value: 0 },
        { title: '30-39', value: 1 },
        { title: '40+', value: 2 },
    ],
    top_courses: mockCourses,
    leaderboard_teams: [
        { rank: 1, team_name: 'M&O', team_members: 5, score: 8000 },
        { rank: 2, team_name: 'Codebashing', team_members: 75, score: 6000 },
        { rank: 3, team_name: 'CxSAST', team_members: 6, score: 5000 },
        { rank: 4, team_name: 'CxAST', team_members: 43, score: 300 },
        { rank: 5, team_name: 'CxIAST', team_members: 2, score: 80 },
        { rank: 6, team_name: 'CxAUTH', team_members: 1, score: 9 },
    ],
    leaderboard_users: [
        { rank: 1, email_address: '1@codebashing.com', score: 8000 },
        { rank: 2, email_address: '2@codebashing.com', score: 6000 },
        { rank: 3, email_address: '3@codebashing.com', score: 5000 },
        { rank: 4, email_address: '4@codebashing.com', score: 300 },
        { rank: 5, email_address: '5@codebashing.com', score: 80 },
        { rank: 6, email_address: '6@codebashing.com', score: 9 },
    ],
};
var mainDashboardData = __assign(__assign({ general: {
        admin_name: null,
        admin_email: 'aaa@codebashing.com',
        active_users: 40,
        total_licenses: 1001,
        subscription_ends: '2021-05-07',
    }, teams: teamsData }, mainDashboardTeamFilterData), { assessments: [
        {
            name: 'Test Assessment',
            topics: ['Injection'],
            start_date: '2021-06-01',
            end_date: '2021-06-30',
            users_assessed: 0,
            users_invited: 2,
            rating: 0.0,
        },
        {
            name: 'jj',
            topics: ['Injection', 'Sensitive Data Exposure', 'Cross Site Request Forgery', 'Cross-Site Scripting'],
            start_date: '2021-05-23',
            end_date: '2021-07-27',
            users_assessed: 0,
            users_invited: 5,
            rating: 0.0,
        },
        {
            name: 'gil assessment',
            topics: ['Sensitive Data Exposure', 'Broken Access Control'],
            start_date: '2021-05-23',
            end_date: '2021-05-25',
            users_assessed: 0,
            users_invited: 3,
            rating: 0.0,
        },
        {
            name: 'jj',
            topics: ['Injection'],
            start_date: '2021-05-17',
            end_date: '2021-05-17',
            users_assessed: 1,
            users_invited: 1,
            rating: 0.67,
        },
        {
            name: 'aa',
            topics: ['Injection', 'Sensitive Data Exposure', 'Cross Site Request Forgery', 'Cross-Site Scripting'],
            start_date: '2021-05-09',
            end_date: '2021-06-05',
            users_assessed: 1,
            users_invited: 8,
            rating: 0.75,
        },
    ] });
var allCoursesData = { all_courses: mockCourses };
var courseDashboardTeamFilterData = {
    primary_courses: { not_started: 10, in_progress: 7, completed: 5 },
    assigned_lessons: { not_started: 1, in_progress: 5, completed: 0 },
    lessons_by_users: [
        { title: '1-6', value: 17 },
        { title: '7-12', value: 0 },
        { title: '13-18', value: 0 },
        { title: '9-23', value: 1 },
    ],
    user_engagement: { engaged: 4, not_engaged: 20 },
    course_user_statistics: [
        {
            email: 'user1@test.com',
            teams: [teamsData[0].name, teamsData[1].name],
            started_at: '2020-10-31',
            completed_at: '2020-11-05',
            duration_seconds: 1205,
            points: 5000,
            lesson_progress: { not_started: 0, completed: 4 },
            certificate: 'https://dev.devcodebashing.com/dashboard/users/16/course_certificate/1',
        },
        {
            email: 'user2@test.com',
            teams: [teamsData[2].name],
            started_at: '2020-10-28',
            completed_at: null,
            duration_seconds: 790,
            points: 3000,
            lesson_progress: { not_started: 2, completed: 2 },
            certificate: null,
        },
    ],
    course_lesson_statistics: [
        {
            order: 1,
            name: 'sql_injection',
            display_name: 'SQL Injection',
            enrolled_users: 2,
            progress: { not_started: 0, completed: 2 },
            average_completion_seconds: 154,
            average_completion_points: 1200,
        },
        {
            order: 2,
            name: 'session_fixation',
            display_name: 'Session Fixation',
            enrolled_users: 2,
            progress: { not_started: 0, completed: 2 },
            average_completion_seconds: 315,
            average_completion_points: 1000,
        },
        {
            order: 3,
            name: 'command_injection',
            display_name: 'Command Injection',
            enrolled_users: 2,
            progress: { not_started: 1, completed: 1 },
            average_completion_seconds: 253,
            average_completion_points: 1000,
        },
        {
            order: 4,
            name: 'reflected_xss',
            display_name: 'Reflected XSS',
            enrolled_users: 2,
            progress: { not_started: 1, completed: 1 },
            average_completion_seconds: 421,
            average_completion_points: 900,
        },
    ],
};
var courseDashboardData = __assign({ teams: teamsData }, courseDashboardTeamFilterData);
var fetchForMap = {
    main_dashboard_page: mainDashboardData,
    main_dashboard_team_filter: mainDashboardTeamFilterData,
    all_courses_page: allCoursesData,
    course_dashboard_page: courseDashboardData,
    course_dashboard_team_filter: courseDashboardTeamFilterData,
};
var fetchAdminDashboardData = function (fetchFor) {
    return fetchForMap[fetchFor];
};
exports.default = fetchAdminDashboardData;
